import BlueButton from "../../../../common/BlueButton/BlueButton";
import BlueSlider from "../../../../common/BlueSlider/BlueSlider";
import LoadingDisplay from "../../../../common/LoadingDisplay/LoadingDisplay";
import { useTranslation } from "react-i18next";
import { useState } from "react";

const TimeDisplayComponent = ({ getSettings, updateUserSettings }) => {
    const { t } = useTranslation("settings");

    const [newInterval, setNewInterval] = useState(null);
    const [newTimeOut, setNewTimeOut] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const currentSettings = getSettings();

    //convert ms to minutes and seconds
    const millisToMinutesAndSeconds = (millisRaw) => {
        let millis = parseInt(millisRaw);
        let minutes = Math.floor(millis / 60000);
        let seconds = ((millis % 60000) / 1000).toFixed(0);

        if (!minutes) {
            const time = (seconds < 10 ? "0" : "") + seconds;
            return t("timeDisplayComponentSeconds", { time });
        } else {
            const time = minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
            return t("timeDisplayComponentMinutes", { time });
        }
    };

    //updates user settings
    const updateUserSettingsState = async () => {
        setIsLoading(true);

        const settingsToUpdate = {};

        if (newInterval !== undefined && newInterval !== null) {
            settingsToUpdate.browserSourceInterval = newInterval;
        }

        if (newTimeOut !== undefined && newTimeOut !== null) {
            settingsToUpdate.browserSourceTimeOut = newTimeOut;
        }

        await updateUserSettings(settingsToUpdate);

        setNewInterval(null);
        setNewTimeOut(null);

        setIsLoading(false);
    };

    const display = (
        <>
            <h3>{t("timeDisplayComponentTitleDisplayTimeOnStream")}</h3>
            <p className="settingsDescription">
                {t("timeDisplayComponentDescriptionHowLongMemeIsActive")}
            </p>
            <BlueSlider
                text={
                    newInterval
                        ? millisToMinutesAndSeconds(newInterval)
                        : millisToMinutesAndSeconds(
                              currentSettings.browserSourceInterval,
                          )
                }
                id="intervalDisplay"
                name="intervalDisplay"
                min={5000}
                max={20000}
                defaultValue={JSON.stringify(
                    currentSettings.browserSourceInterval,
                )}
                onChange={(e) => setNewInterval(parseInt(e.target.value))}
                step={500}
            />
            <br />
            <br />
            <h3>{t("timeDisplayComponentTitleMemeFrequency")}</h3>
            <p className="settingsDescription">
                {t("timeDisplayComponentDescriptionMemeFrequency")}
            </p>
            <BlueSlider
                text={
                    newTimeOut
                        ? millisToMinutesAndSeconds(newTimeOut)
                        : millisToMinutesAndSeconds(
                              currentSettings.browserSourceTimeOut,
                          )
                }
                id="timeOutDisplay"
                name="timeOutDisplay"
                min={1}
                max={300001}
                defaultValue={JSON.stringify(
                    currentSettings.browserSourceTimeOut,
                )}
                onChange={(e) => setNewTimeOut(parseInt(e.target.value))}
                step={10000}
            />
            <br />
            <br />
            {newInterval || newTimeOut ? (
                <BlueButton
                    text={t("settingsSaveButton")}
                    onClick={updateUserSettingsState}
                    isCenter={true}
                />
            ) : (
                <></>
            )}
        </>
    );

    const loadingDisplay = (
        <div className="chatNotificationDisplayLoading">
            <LoadingDisplay invert={true} />
        </div>
    );

    return isLoading ? loadingDisplay : display;
};

export default TimeDisplayComponent;
